// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Contact_wrapper__hupgJ","list":"Contact_list__26OUE","list__item":"Contact_list__item__1N4zJ"};